import ResourceSvc from '@/services/resource.svc.js';
const request = new ResourceSvc();
import { EventBus } from '@/services/Event.js';
import { Table, TableColumn } from 'element-ui';
import TableItem from '../table-item/table-item.vue';

export default {
    name: 'RaceTableLayout',
    props: {
        data: Array,
        isProcessing: Boolean,
        from: Number,
        to: Number,
        total: Number,
        page: Number,
        perPage: Number,
        id: [Number, String]
    },
    components: {
        'table-item': TableItem,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
    },
    data() {
        return {
        }
    },
    computed: {
    },
    methods: {
        showError(message) {
            if (!message) {
                message = 'Something went wrong. Incorrect request!';
            }
            this.$notify({
                message: message,
                type: 'danger',
                timeout: 5000
            });
        },
        showSuccess(message) {
            if (!message) {
                message = 'Operation success!';
            }

            this.$notify({
                message: message,
                type: 'success',
                timeout: 1000
            });
        },
        console(message) {
            if (console && console.log) {
                if (message) {
                    console.log(message);
                }
                else {
                    var date = new Date();
                    console.log("-------> " + date.getMinutes() + ":" + date.getSeconds());
                }
            }
        },
        init() {
            this.load();
        },
        load() {

        },
        rowClick(data) {
            this.$emit("update:id", data.id);
        },
        getAddress(row) {
            var result = row.userData['Address 1'];

            if (row.userData['Address 2']) {
                result += " " + row.userData['Address 2'];
            }

            if (row.userData['Address 3']) {
                result += " " + row.userData['Address 3'];
            }

            return result;
        }
    },
    mounted() {
        this.init();
    }
};



// WEBPACK FOOTER //
// ./src/components/user/dashboard/pages/races/view-race/race-registration/table/table.js